import { useTranslation } from "react-i18next";
import { DateFormat } from "../../utils/DateFormat";

export default function TransactionsTable({ data }) {
  const { t } = useTranslation();

  const StatusBadge = ({ status }) => {
    const statusStyles = {
      completed: 'bg-green-100 text-green-800 border-green-200',
      cancelled: 'bg-red-100 text-red-800 border-red-200'
    };

    return (
      <span className={`inline-flex px-2.5 py-0.5 rounded-full text-sm font-medium border ${statusStyles[status.toLowerCase()] || ''}`}>
        {status}
      </span>
    );
  };

  return (
    <div className="w-full">
      {/* Mobile view - List format */}
      <div className="block md:hidden space-y-4">
        {data.map((item, index) => (
          <div key={index} className="bg-white p-4 rounded-lg shadow space-y-3 border border-gray-200">
            <div className="flex justify-between items-center">
              <span className="text-sm font-semibold text-gray-900">#{item.num_payment}</span>
              <StatusBadge status={item.status} />
            </div>
            
            <dl className="space-y-2 text-sm">
              <div className="flex justify-between">
                <dt className="text-gray-500">{t("cardnumber")}</dt>
                <dd className="font-medium text-gray-900">**{item.cardnumber}</dd>
              </div>
              
              <div className="flex justify-between">
                <dt className="text-gray-500">{t("expirationdate")}</dt>
                <dd className="font-medium text-gray-900">{item.exp_date}</dd>
              </div>
              
              <div className="flex justify-between">
                <dt className="text-gray-500">{t("amount")}</dt>
                <dd className="font-medium text-gray-900">{item.amount} MAD</dd>
              </div>
              
              <div className="flex justify-between">
                <dt className="text-gray-500">{t("payment-method")}</dt>
                <dd className="font-medium text-gray-900 capitalize">{t(item.method)}</dd>
              </div>
              
              <div className="flex justify-between">
                <dt className="text-gray-500">{t("date&time")}</dt>
                <dd className="font-medium text-gray-900">
                  <DateFormat dateString={item.created_at} />
                </dd>
              </div>
            </dl>
          </div>
        ))}
      </div>

      {/* Desktop view - Table format */}
      <div className="hidden md:block">
        <div className="overflow-hidden rounded-lg border border-gray-200">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Transaction ID
                </th>
                <th scope="col" className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("cardnumber")}
                </th>
                <th scope="col" className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("expirationdate")}
                </th>
                <th scope="col" className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("amount")}
                </th>
                <th scope="col" className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("payment-method")}
                </th>
                <th scope="col" className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("date&time")}
                </th>
                <th scope="col" className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {data.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="p-3 whitespace-nowrap text-sm font-medium text-gray-900">
                    {item.num_payment}
                  </td>
                  <td className="p-3 whitespace-nowrap text-sm text-gray-500">
                    **{item.cardnumber}
                  </td>
                  <td className="p-3 whitespace-nowrap text-sm text-gray-500">
                    {item.exp_date}
                  </td>
                  <td className="p-3 whitespace-nowrap text-sm text-gray-500">
                    {item.amount} MAD
                  </td>
                  <td className="p-3 whitespace-nowrap text-sm text-gray-500 capitalize">
                    {t(item.method)}
                  </td>
                  <td className="p-3 whitespace-nowrap text-sm text-gray-500">
                    <DateFormat dateString={item.created_at} />
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    <StatusBadge status={item.status} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
